// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"147":"a0c8e834","576":"a0283d14"}[chunkId] + ".chunk.css";
};